export default function ClassNames(...classNames: String[]) {
  return classNames.join(" ");
}
